import { Link } from "react-router-dom";
import type { Anime } from "@/mocks/anime";

interface RankingSidebarProps {
  items: Anime[];
}

export default function RankingSidebar({ items }: RankingSidebarProps) {
  const rankColor = (i: number) => {
    if (i === 0) return "bg-primary-500 text-background-50";
    if (i === 1) return "bg-primary-400 text-background-50";
    if (i === 2) return "bg-primary-300 text-foreground-950";
    return "bg-background-200 text-foreground-600";
  };

  return (
    <aside className="w-full lg:w-[340px] shrink-0">
      <div className="rounded-lg bg-background-50 border border-background-200 p-5 lg:sticky lg:top-24">
        <div className="flex items-center gap-2 mb-4">
          <span className="w-8 h-8 rounded-md bg-accent-100 text-accent-700 flex items-center justify-center text-lg">
            <i className="ri-trophy-line"></i>
          </span>
          <div>
            <h2 className="text-base font-bold text-foreground-950">热门动漫榜单</h2>
            <p className="text-xs text-foreground-600">按关注度与点击量实时排行</p>
          </div>
        </div>

        <ol className="flex flex-col divide-y divide-background-200">
          {items.map((anime, i) => (
            <li key={anime.id}>
              <Link
                to={`/detail/${anime.id}`}
                className="group flex items-center gap-3 py-3 cursor-pointer"
              >
                <span
                  className={`w-6 h-6 rounded-md flex items-center justify-center text-xs font-bold shrink-0 ${rankColor(i)}`}
                >
                  {i + 1}
                </span>
                <div className="min-w-0 flex-1">
                  <p className="text-sm font-medium text-foreground-950 line-clamp-1 group-hover:text-primary-700 transition-colors">
                    {anime.title}
                  </p>
                  <p className="text-xs text-foreground-500 mt-0.5">
                    {anime.categories[0]} · {Math.round(anime.views / 1000)}k 关注
                  </p>
                </div>
                <span className="text-xs font-semibold text-accent-600 shrink-0">
                  {anime.rating.toFixed(1)}
                </span>
              </Link>
            </li>
          ))}
        </ol>
      </div>
    </aside>
  );
}